"use strict";

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  ", "\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  ", "\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  padding: 24px;\n  margin-top: 68px;\n  @media (max-width: ", "px) {\n    padding: 0px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  position: absolute;\n  min-height: 100vh;\n  width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  max-width: 1021px;\n  margin: 0 auto 64px auto;\n  @media (max-width: ", "px) {\n    margin: 24px auto 64px auto;\n  }\n  @media (max-width: ", "px) {\n    margin: 24px auto 64px auto;\n    max-width: 100%;\n  }\n  @media (max-width: 1050px) and (min-width: ", "px) {\n    max-width: calc(100% - 48px);\n  }\n  position: relative;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  max-width: 940px;\n  margin: 64px auto 0;\n  padding: 40px 32px;\n  position: relative;\n  @media (max-width: ", "px) {\n    padding: 24px 16px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  color: ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

exports.Content = styled_components_1.default.section(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.copy;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts.bodyStyle;
});
exports.BodyContent = styled_components_1.default.div(_templateObject2(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.grid.breakpoints.md;
});
exports.PageContent = styled_components_1.default.div(_templateObject3(), function (_ref4) {
  var theme = _ref4.theme;
  return theme.grid.breakpoints.sm;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.grid.breakpoints.md;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.grid.breakpoints.lg;
});
exports.Container = styled_components_1.default.div(_templateObject4(), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.white;
});
exports.FullBodyContent = styled_components_1.default.div(_templateObject5(), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.background;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.grid.breakpoints.md;
});
exports.VerticalLayout = styled_components_1.default.div(_templateObject6(), function (_ref10) {
  var width = _ref10.width;
  return width ? "width: ".concat(width) : '';
}, function (_ref11) {
  var height = _ref11.height;
  return height ? "height: ".concat(height) : '';
});
exports.HorizontalLayout = styled_components_1.default.div(_templateObject7(), function (_ref12) {
  var width = _ref12.width;
  return width ? "width: ".concat(width) : '';
}, function (_ref13) {
  var height = _ref13.height;
  return height ? "height: ".concat(height) : '';
});